// Test IDs for the Mi Perfil feature.

export const PROFILE = {
        nameInput: 'profile-name-input',
        emailInput: 'profile-email-input',
        phoneInput: 'profile-phone-input',
        photoUpload: 'profile-photo-upload',
        specialtyInput: 'profile-specialty-input',
        bioInput: 'profile-bio-input',
        saveButton: 'profile-save-button',
        currentPasswordInput: 'profile-current-password-input',
        newPasswordInput: 'profile-new-password-input',
        changePasswordButton: 'profile-change-password-button',
};
